import { useInfiniteQuery } from '@tanstack/react-query'
import type { IProviderSurveyHistoryItem } from '@brushfire/types'
import { apiClient } from '@/api/http/client'
import type { ApiResponse } from '@/api/http/types'
import { queryKeys } from '@/api/query-keys'

const PAGE_SIZE = 20

type HistoryPageResult = {
  items: IProviderSurveyHistoryItem[]
  total: number
  page: number
  pageSize: number
  hasMore: boolean
}

export function useSurveyHistoryInfinite() {
  return useInfiniteQuery({
    queryKey: queryKeys.spSurveyHistory.list(PAGE_SIZE),
    initialPageParam: 1,
    retry: import.meta.env.DEV ? false : 1,
    queryFn: async ({ pageParam }) => {
      const { data } = await apiClient.get<ApiResponse<IProviderSurveyHistoryItem[]>>(
        '/api/v1/sp/surveys/history',
        { params: { page: pageParam, pageSize: PAGE_SIZE } },
      )
      const meta = data.meta
      const page = meta?.page ?? pageParam
      const pageSize = meta?.per_page ?? PAGE_SIZE
      const total = meta?.total ?? data.data.length
      const hasMore = page * pageSize < total
      return { items: data.data, total, page, pageSize, hasMore } satisfies HistoryPageResult
    },
    getNextPageParam: (lastPage) => (lastPage.hasMore ? lastPage.page + 1 : undefined),
  })
}
